import { JobStatus } from '@y42/json-schema';

export interface BadgeColor {
  selector: JobStatus;
  textColor: string;
  backgroundColor: string;
  darkBackgroundColor: string;
}

const darkNeutralBackground = 'status-neutral-bg-blue-dark';
const neutralBackground = 'status-neutral-bg-blue';
const neutralText = 'status-neutral-text-blue';

const darkGoodBackground = 'status-success-bg-dark';
const goodBackground = 'status-success-bg';
const goodText = 'status-success-text';

const darkBadBackground = 'status-failure-bg-dark';
const badBackground = 'status-failure-bg';
const badText = 'status-failure-text';

export const BadgeColorByJobStatus: Record<BadgeColor['selector'], BadgeColor> = {
  [JobStatus.New]: {
    selector: JobStatus.New,
    textColor: neutralText,
    backgroundColor: neutralBackground,
    darkBackgroundColor: darkNeutralBackground,
  },
  [JobStatus.Queued]: {
    selector: JobStatus.Queued,
    textColor: neutralText,
    backgroundColor: neutralBackground,
    darkBackgroundColor: darkNeutralBackground,
  },
  [JobStatus.Pending]: {
    selector: JobStatus.Pending,
    textColor: neutralText,
    backgroundColor: neutralBackground,
    darkBackgroundColor: darkNeutralBackground,
  },
  [JobStatus.Ready]: {
    selector: JobStatus.Ready,
    textColor: goodText,
    backgroundColor: goodBackground,
    darkBackgroundColor: darkGoodBackground,
  },
  [JobStatus.Invalid]: {
    selector: JobStatus.Invalid,
    textColor: badText,
    backgroundColor: badBackground,
    darkBackgroundColor: darkBadBackground,
  },
  [JobStatus.InvalidPartial]: {
    selector: JobStatus.InvalidPartial,
    textColor: badText,
    backgroundColor: badBackground,
    darkBackgroundColor: darkBadBackground,
  },
  [JobStatus.PartiallyEmpty]: {
    selector: JobStatus.PartiallyEmpty,
    textColor: badText,
    backgroundColor: badBackground,
    darkBackgroundColor: darkBadBackground,
  },
  [JobStatus.PartiallyReady]: {
    selector: JobStatus.PartiallyReady,
    textColor: goodText,
    backgroundColor: goodBackground,
    darkBackgroundColor: darkGoodBackground,
  },
  [JobStatus.Canceled]: {
    selector: JobStatus.Canceled,
    textColor: badText,
    backgroundColor: badBackground,
    darkBackgroundColor: darkBadBackground,
  },
  [JobStatus.Expired]: {
    selector: JobStatus.Expired,
    textColor: neutralText,
    backgroundColor: neutralBackground,
    darkBackgroundColor: darkNeutralBackground,
  },
};
